import "../css/index.less";
import { Tools } from "../../../common/func/tools/index";

// setTimeout(function () {
//   var userAgent = navigator.userAgent;
//   var isChrome = userAgent.indexOf("Chrome") > -1;
//   if (Tools.isPC()) {
//     if (isChrome) {
//       $(".download-box").css({
//         opacity: 1,
//         zIndex: 999,
//       });
//     }
//   }
// }, 3000);
function getUrlParam(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"),
    r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  } else {
    return null;
  }
}
$(document).ready(function () {
  // if(Tools.isPC()&&!Tools.isMac()){
  //   if (getUrlParam("td") == "source_product") {
  //     $('a[data-handle="downLink"]').attr("href","https://www.amoyshare.info/download-software/tuneber-win.exe")
  //   }
  //   else{
  //     $('a[data-handle="downLink"]').attr("href","https://www.amoyshare.info/download-software/tuneber-mac.dmg")
  //   }
  // }
  // if (Tools.isMac()) {
  //   $(".download-tips").css({
  //     "display": "block",
  //     "right": "63px"
  //   })
  // } else {
  //   $(".download-tips").css({
  //     "display": "block"
  //   })
  // }
  $('a[data-handle="downLink"]')[0].click();
  setTimeout(function () {
    var userAgent = navigator.userAgent;
    var isChrome = userAgent.indexOf('Chrome') > -1;
    if (Tools.isPC()) {
      if (isChrome) {
        $('.download-tips').css({
          opacity: 1,
        });
      }
    }
  }, 0);
});